import { createContext, useContext, useMemo, useState, useCallback } from 'react';

const DemoPersonaContext = createContext(null);

export function DemoPersonaProvider({ children }) {
  const [session, setSession] = useState(null);

  const enterDemoPersona = useCallback((payload) => {
    setSession({
      persona: payload.persona,
      programmeId: payload.programmeId,
      accessRole: payload.access_role || 'member',
      roleLabel: payload.role_label || payload.persona?.job_title || 'Demo user',
    });
  }, []);

  const exitDemoPersona = useCallback(() => setSession(null), []);

  const value = useMemo(() => ({
    session,
    activePersona: session?.persona ?? null,
    activeProgrammeId: session?.programmeId ?? null,
    demoAccessRole: session?.accessRole ?? null,
    isDemoView: Boolean(session),
    enterDemoPersona,
    exitDemoPersona,
  }), [session, enterDemoPersona, exitDemoPersona]);

  return (
    <DemoPersonaContext.Provider value={value}>
      {children}
    </DemoPersonaContext.Provider>
  );
}

export function useDemoPersona() {
  const ctx = useContext(DemoPersonaContext);
  if (!ctx) {
    throw new Error('useDemoPersona must be used within DemoPersonaProvider');
  }
  return ctx;
}

/** Safe hook when provider may be absent (tests). */
export function useDemoPersonaOptional() {
  return useContext(DemoPersonaContext);
}
